import toast from "react-hot-toast";
import axiosInstance from "./axiosInstance";

const subscriptionService = {
  getAll: async () => {
    try {
      const response = await axiosInstance.get("/subscription/all");
      console.log("Response from login API:", response);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
  getAllPurchasedSubscriptions: async () => {
    try {
      const response = await axiosInstance.get("/subscription/all-purchased");
      console.log("Response from login API:", response);
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
};

export default subscriptionService;
